module.exports = __webpack_public_path__ + "static/media/STR.de5b1b1e.png";